import { render, staticRenderFns } from "./SchoolServicesEditTab.vue?vue&type=template&id=7964add8&scoped=true"
import script from "./SchoolServicesEditTab.vue?vue&type=script&lang=js"
export * from "./SchoolServicesEditTab.vue?vue&type=script&lang=js"
import style0 from "./SchoolServicesEditTab.vue?vue&type=style&index=0&id=7964add8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7964add8",
  null
  
)

export default component.exports